import React from 'react';
import { useNavigate } from 'react-router-dom';
import { 
  Box, 
  Container, 
  Paper, 
  Typography, 
  Button, 
  Grid,
  Card,
  CardContent,
  Divider
} from '@mui/material';
import CancelIcon from '@mui/icons-material/Cancel';
import MainLayout from '../../components/layout/MainLayout';

function PaymentCancelPage() {
  const navigate = useNavigate();

  const goToSessions = () => {
    navigate('/sessions');
  };

  const tryAgain = () => {
    // Navigate back to the enrollment page
    // You would typically want to navigate back to the originating enrollment page
    // This is a simple implementation - you might want to store the session ID in state/localStorage
    navigate(-1);
  };

  return (
    <MainLayout>
      <Container maxWidth="md" sx={{ py: 4 }}>
        <Paper elevation={3} sx={{ p: 4, borderRadius: 2 }}>
          <Box sx={{ textAlign: 'center', mb: 4 }}>
            <CancelIcon color="error" sx={{ fontSize: 80, mb: 2 }} />
            <Typography variant="h4" component="h1" gutterBottom>
              Payment Cancelled
            </Typography>
            <Typography variant="body1" color="text.secondary">
              Your payment process was cancelled. No charges have been made to your account.
            </Typography>
          </Box>

          <Divider sx={{ my: 3 }} />

          <Card sx={{ mb: 3, bgcolor: 'info.light', color: 'white' }}>
            <CardContent>
              <Typography variant="h6">What would you like to do?</Typography>
              <Typography variant="body2" sx={{ mt: 1 }}>
                You can try the payment again or browse other available sessions.
              </Typography>
            </CardContent>
          </Card>

          <Grid container spacing={2} justifyContent="center" sx={{ mt: 3 }}>
            <Grid item>
              <Button 
                variant="contained" 
                color="primary" 
                onClick={tryAgain}
              >
                Try Again
              </Button>
            </Grid>
            <Grid item>
              <Button 
                variant="outlined" 
                onClick={goToSessions}
              >
                Browse Sessions
              </Button>
            </Grid>
          </Grid>
        </Paper>
      </Container>
    </MainLayout>
  );
}

export default PaymentCancelPage;